import styled, { css } from 'styled-components';

import { AsideCardProps } from '.';

export const Wrapper = styled.div<AsideCardProps>`
  margin-bottom: 32px;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.white100};

  &::last-child {
    margin-bottom: 0;
  }

  ${({ theme }) => theme.media.mobile} {
    margin-bottom: 16px;
    border-width: 0;
    border-radius: 0;
  }

  ${({ noPadding, theme }) =>
    !noPadding &&
    css`
      padding: 30px;
      ${theme.media.mobile} {
        padding: 30px 20px;
      }
    `}
`;
